import { getAskAiAdminPath } from '@lumapps/ask-ai/utils';
import { Route, AppId, createEntityManagementRoutes } from '@lumapps/router';

import { AskAiConfiguration } from './types';

const { baseRoute, createRoute, editRoute, getEditRoute } = createEntityManagementRoutes({
    slug: getAskAiAdminPath('configurations'),
    id: 'ai-search-configurations',
    appId: AppId.backOffice,
});

export const getAskAiEditConfigurationRoute = (configurationId: AskAiConfiguration['id']): Route =>
    getEditRoute(configurationId);

export {
    baseRoute as askAiConfigurationsAdminRoute,
    editRoute as askAiEditConfigurationRoute,
    createRoute as askAiCreateConfigurationRoute,
};
